/* eslint-disable no-unused-vars */
import Vue from 'vue'

import app from '@/app.js'
import { AESencrypt } from '@/modules/crypto'
import offThread from '@/my-worker'

import sndAlerts from '@/modules/sounds'

const vm = new Vue()

// Utilitário para limpar timers
function clearTimer (timer) {
  if (timer) {
    clearTimeout(timer)
    timer = null
  }
}

const socket = {
  namespaced: true,
  state: {
    socket: {
      isConnected: false,
      isOnline: true,
      isLogged: false,
      reconnectError: false,
      xProtocolAdm: {
        data: {},
        output: ''
      },
      firstLoad: false,
      firstClose: true,
      customDataFirstLoad: false,
      doneResponse: false,
      timeOut: null,
      responseCrypto: false
    },
    custom_data: {},
    external_api: {
      transport: {}
    },
    cron: {
      requestCron: 0,
      processCron: 0,
      responseCron: 0
    }
  },
  mutations: {
    SOCKET_ONOPEN (state, event) {
      if (this.state.app.dev_mode) console.log('%cSocket Opened', 'color: #4CAF50; font-weight:bold;')
      Vue.prototype.$socket = event.currentTarget
      state.socket.isConnected = true
      if (this.state.login.logged && this.state.login.auth && this.state.login.iv) {
        state.cron.requestCron = new Date()
        state.socket.isLogged = true
        let requestData = {
          auth: {
            aa: this.state.login.auth,
            aw: this.state.login.iv
          },
          protocol: 'DATA'
        }
        if (typeof this.state.login.preferences.sound !== 'undefined' && this.state.login.preferences.sound) sndAlerts.connected.play().catch(function () {})
        state.socket.firstClose = true
        if (this.state.app.dev_mode) {
          console.log('%cSocket Working', 'color: #FF9800; font-weight:bold;')
          console.log(' IN:', requestData)
        }
        offThread.encrypt2(requestData)
          .then(encRequest => {
            let request = {
              aa: encRequest.encrypted,
              aw: encRequest.iv
            }
            vm.$socket.sendObj(request)
            state.cron.responseCron = new Date()
          }).catch(error => {
            if (this.state.app.dev_mode) console.log(error)
            if (typeof this.state.login.preferences.sound !== 'undefined' && this.state.login.preferences.sound) sndAlerts.error.play().catch(function () {})
          })
      }
    },
    SOCKET_ONCLOSE (state, event) {
      if (this.state.app.dev_mode) console.log('%cSocket Closed', 'color: #f44336; font-weight:bold;')
      clearTimer(state.socket.timeOut)
      if (state.socket.firstClose) if (typeof this.state.login.preferences.sound !== 'undefined' && this.state.login.preferences.sound) sndAlerts.disconnected.play().catch(function () {})
      state.socket.firstClose = false
      state.socket.isConnected = false
      state.socket.isLogged = false
      this.state.interfacecfg.snackbar = {
        active: true,
        message: this.state.language.snackbar.error.disconnected_server,
        color: 'red'
      }
    },
    SOCKET_ONERROR (state, event) {
      state.socket.isConnected = false
      state.socket.isLogged = false
      clearTimer(state.socket.timeOut)
      if (typeof this.state.login.preferences.sound !== 'undefined' && this.state.login.preferences.sound) sndAlerts.error.play().catch(function () {})
      if (this.state.app.dev_mode) console.error(state, event)
      this.state.interfacecfg.snackbar = {
        active: true,
        message: this.state.language.snackbar.error.server,
        color: 'red'
      }
    },
    SOCKET_ONMESSAGE (state, data) {
      const vm = this
      function logout () {
        document.cookie.split(';').forEach(function (c) { document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/') })
        localStorage.setItem('logged', AESencrypt(JSON.stringify(false), app, 1))
        localStorage.setItem('session', AESencrypt(JSON.stringify(false), app, 1))
        localStorage.setItem('aa', '')
        localStorage.setItem('aw', '')
        Vue.set(vm.state.login, 'logged', false)
        Vue.set(vm.state.login, 'auth', '')
        Vue.set(vm.state.login, 'iv', '')
        Vue.set(vm.state.login.logged_user, 'id', 0)
        Vue.set(vm.state.login.logged_user, 'name', '')
        Vue.set(vm.state.login.logged_user, 'function', '')
        vm.state.interfacecfg.login_loading = false
      }
      const responseTime = (state.cron.responseCron > 0 ? ((new Date() - state.cron.responseCron) / 1000) : 0)
      state.cron.processCron = new Date()
      // Processamento assíncrono para evitar bloqueios
      setTimeout(() => {
        if (data) {
          offThread.decrypt(data, state.socket.responseCrypto)
            .then(response => {
              data = response
              if (data && Object.keys(data).length > 0) {
                state.socket.isLogged = (data.user && data.user.logged)
                // state.socket.isOnline = (data.socket && data.socket.online)
                state.socket.isOnline = true
                this.state.login.logged = (data.user && data.user.logged)
                this.state.login.logged_user = data.user
                offThread.encrypt(this.state.login.logged).then(encLogged => localStorage.setItem('logged', encLogged, app, 1))
                offThread.encrypt(data.user).then(encSession => localStorage.setItem('session', encSession, app, 1))
                switch (data.protocol) {
                  case 'LOGIN':
                    this.state.interfacecfg.login_loading = false
                    if (data.success && data.user.logged) {
                      this.state.interfacecfg.login_loading = false
                      state.socket.doneResponse = true
                      setTimeout(function () { state.socket.doneResponse = false }, 999)
                      if (typeof this.state.login.preferences.sound !== 'undefined' && this.state.login.preferences.sound) sndAlerts.login.play().catch(function () {})
                      this.state.interfacecfg.snackbar = {
                        active: true,
                        message: this.state.language.snackbar.success.welcome,
                        color: 'green'
                      }
                    } else {
                      if (typeof this.state.login.preferences.sound !== 'undefined' && this.state.login.preferences.sound) sndAlerts.incorrect.play().catch(function () {})
                      logout()
                      this.state.interfacecfg.snackbar = {
                        active: true,
                        message: this.state.language.snackbar.error.incorrect_login,
                        color: 'red'
                      }
                    }
                    break
                  case 'LOGOUT':
                    if (data.success) {
                      logout()
                      Vue.set(this.state.login.logged_user, 'permissions', [])
                      this.state.interfacecfg.snackbar = {
                        active: true,
                        message: this.state.language.snackbar.success.logout,
                        color: 'green'
                      }
                    } else {
                      this.state.interfacecfg.snackbar = {
                        active: true,
                        message: this.state.language.snackbar.error.logout,
                        color: 'red'
                      }
                    }
                    break
                  case 'DATA':
                    if (!(data.success && data.user.logged)) {
                      this.state.interfacecfg.snackbar = {
                        active: true,
                        message: this.state.language.snackbar.error.query_error,
                        color: 'red'
                      }
                    }
                    break
                  case 'SAVE':
                    if (data.success && data.user.logged) {
                      state.socket.doneResponse = true
                      setTimeout(function () { state.socket.doneResponse = false }, 99)
                      if (typeof this.state.login.preferences.sound !== 'undefined' && this.state.login.preferences.sound) sndAlerts.success.play().catch(function () {})
                      this.state.interfacecfg.snackbar = {
                        active: (!data.ignoreResponseBar) || false,
                        message: this.state.language.snackbar.success.saved,
                        color: 'green'
                      }
                    } else {
                      if (typeof this.state.login.preferences.sound !== 'undefined' && this.state.login.preferences.sound) sndAlerts.error.play().catch(function () {})
                      this.state.interfacecfg.snackbar = {
                        active: (!data.ignoreResponseBar) || false,
                        message: this.state.language.snackbar.error.save_error,
                        color: 'red'
                      }
                    }
                    break
                  case 'ACTION':
                    if (data.success && data.user.logged) {
                      if (typeof this.state.login.preferences.sound !== 'undefined' && this.state.login.preferences.sound) sndAlerts.success.play().catch(function () {})
                      this.state.interfacecfg.snackbar = {
                        active: (!data.ignoreResponseBar) || false,
                        message: this.state.language.snackbar.success.saved,
                        color: 'green'
                      }
                    } else {
                      if (typeof this.state.login.preferences.sound !== 'undefined' && this.state.login.preferences.sound) sndAlerts.error.play().catch(function () {})
                      this.state.interfacecfg.snackbar = {
                        active: (!data.ignoreResponseBar) || false,
                        message: this.state.language.snackbar.error.action_error,
                        color: 'red'
                      }
                    }
                    break
                  case 'MIXED':
                    if (data.success && data.user.logged) {
                      state.socket.doneResponse = true
                      setTimeout(function () { state.socket.doneResponse = false }, 999)
                      this.state.interfacecfg.snackbar = {
                        active: (!data.ignoreResponseBar) || false,
                        message: this.state.language.snackbar.success.saved,
                        color: 'green'
                      }
                    } else {
                      this.state.interfacecfg.snackbar = {
                        active: (!data.ignoreResponseBar) || false,
                        message: this.state.language.snackbar.error.action_error,
                        color: 'red'
                      }
                    }
                    break
                  case 'CUSTOM_DATA':
                    if (data.success && data.user.logged) {
                      Vue.set(state.socket, 'custom_data', Object.assign(data.data.custom_data, {}))
                      state.socket.customDataFirstLoad = true
                    } else {
                      this.state.interfacecfg.snackbar = {
                        active: (!data.ignoreResponseBar) || false,
                        message: this.state.language.snackbar.error.query_error,
                        color: 'red'
                      }
                    }
                    break
                  case 'EXTERNAL_API':
                    if (data.success && data.user.logged) {
                      Vue.set(state.external_api, 'transport', Object.assign({}, data.api_response))
                    } else {
                      this.state.interfacecfg.snackbar = {
                        active: true,
                        message: this.state.language.snackbar.error.action_error,
                        color: 'red'
                      }
                    }
                    break
                  case 'X::ADMIN__MANAGER':
                    if (data.success && data.user.logged) {
                      Vue.set(state.socket.xProtocolAdm, 'data', Object.assign(data.manager, {}))
                      Vue.set(state.socket.xProtocolAdm, 'output', JSON.stringify(data, undefined, 4))
                    } else {
                      this.state.interfacecfg.snackbar = {
                        active: true,
                        message: this.state.language.snackbar.error.action_error,
                        color: 'red'
                      }
                    }
                    break
                }

                /* SOUND ALERTS */
                var newNotifications = Object.values(data.data.notifications || {})
                if (state.socket.firstLoad && (typeof newNotifications !== 'undefined' && newNotifications.length > 0)) {
                  var oldNotifications = Object.values(this.state.data.notifications || {})
                  let toggleAlert = false
                  newNotifications.forEach(function (page) {
                    var oldMatch = oldNotifications.find((el, i) => el.route === page.route)
                    let oldValue = (oldMatch && oldMatch.unread > 0 ? parseInt(oldMatch.unread) : 0)
                    let newValue = (page.unread > 0 ? parseInt(page.unread) : 0)
                    if (newValue > oldValue) toggleAlert = true
                  })
                  if (toggleAlert) if (typeof this.state.login.preferences.sound !== 'undefined' && this.state.login.preferences.sound) sndAlerts.notification.play().catch(function () {})
                }

                /* DATA UPDATE */
                  // Atualiza apenas propriedades alteradas, evitando cópias profundas
                  if (data.options) {
                    this.state.options = Object.assign({}, this.state.options, data.options)
                  }
                  if (data.data) {
                    // Troca a REFERENCIA do state.data (novo objeto) p/ o getter getData re-avaliar e
                    // TODAS as listas re-renderizarem em tempo real. Vue.set por-chave nao trocava a
                    // referencia -> getter cacheado nao disparava -> so atualizava no F5/re-mount.
                    this.state.data = Object.assign({}, this.state.data, data.data)
                }
                /* if (typeof state.socket.custom_data !== 'undefined' && Object.keys(state.socket.custom_data).length > 0) {
                  Vue.set(state.socket, 'custom_data', Object.assign(data.data, {}))
                } */

                /* FINISH */
                state.socket.firstLoad = true
                this.state.interfacecfg.overlay = false
                this.state.interfacecfg.loading = false

                if (this.state.app.dev_mode) {
                  if (responseTime === 0) console.log('%cSocket Working', 'color: #FF9800; font-weight:bold;')
                  console.log(' OUT:', data)
                  const processTime = (new Date() - state.cron.processCron) / 1000
                  const requestTime = (state.cron.requestCron > 0 ? (new Date() - state.cron.requestCron) / 1000 : processTime)
                  console.log(' CRON:')
                  const srtCss = (responseTime < 0.5 ? 'color: #4CAF50; font-weight:bold;' : 'color: #f44336; font-weight:bold;')
                  console.log('   - Server Response Time: %c' + responseTime + 's', srtCss)
                  const dptCss = (processTime < 4 ? 'color: #4CAF50; font-weight:bold;' : 'color: #f44336; font-weight:bold;')
                  console.log('   - Data Process Time: %c' + processTime + 's', dptCss)
                  const frtCss = (requestTime < 5 ? 'color: #4CAF50; font-weight:bold;' : 'color: #f44336; font-weight:bold;')
                  console.log('   - Full Request Time: %c' + requestTime + 's', frtCss)
                  state.cron.requestCron = 0
                  state.cron.processsCron = 0
                  state.cron.responseCron = 0
                }
              } else {
                if (typeof this.state.login.preferences.sound !== 'undefined' && this.state.login.preferences.sound) sndAlerts.error.play().catch(function () {})
                this.state.interfacecfg.snackbar = {
                  active: true,
                  message: this.state.language.snackbar.error.invalid_data,
                  color: 'red'
                }
              }
            })
        }
      }, 0)
    },
    SOCKET_RECONNECT (state, count) {
      /* this.state.interfacecfg.snackbar = {
        active: true,
        message: `${this.state.language.snackbar.error.reconnect_delay} ${count}s`,
        color: 'red'
      } */
    },
    SOCKET_RECONNECT_ERROR (state) {
      state.socket.reconnectError = true
      this.state.interfacecfg.snackbar = {
        active: true,
        message: this.state.language.snackbar.error.server,
        color: 'red'
      }
    }
  },
  actions: {
    connectSocket ({ commit, state, dispatch }) {
      if (app.socket_manual) {
        vm.$connect()
      }
    },

    sendSocket ({ commit, state }, data) {
      state.cron.requestCron = new Date()
      if (this.state.app.dev_mode) {
        console.log('%cSocket Working', 'color: #FF9800; font-weight:bold;')
        console.log(' IN:', data)
      }
      // Remove setTimeout longo e desnecessário
      offThread.encrypt2(data)
        .then(encRequest => {
          let request = {
            aa: encRequest.encrypted,
            aw: encRequest.iv
          }
          vm.$socket.sendObj(request)
          state.cron.responseCron = new Date()
        }).catch(error => {
          if (this.state.app.dev_mode) console.log(error)
        })
    },

    closeSocket ({ commit, state }) {
      if (this.state.app.dev_mode) console.log('Closing Socket')
      vm.$disconnect()
    },

    CUSTOM_DATA ({ commit, state, dispatch }, data) {
      let request = {
        protocol: 'CUSTOM_DATA',
        auth: {
          aa: this.state.login.auth,
          aw: this.state.login.iv
        }
      }
      if (Object.keys(data).length > 0) request.call = data
      this.state.interfacecfg.loading = true
      dispatch('sendSocket', request)
    },

    ADM_PROTOCOL ({ commit, state, dispatch }, data) {
      let request = {
        protocol: 'X::ADMIN__MANAGER',
        auth: {
          aa: this.state.login.auth,
          aw: this.state.login.iv
        }
      }
      if (data.type > 0) request.call = data
      dispatch('sendSocket', request)
    }
  }
}

// Finalização do worker ao destruir o módulo (caso Vuex hot reload ou app destroy)
if (module && module.hot) {
  module.hot.dispose(() => {
    offThread.terminate && offThread.terminate()
  })
}

export default socket
